import { useParams, useSearchParams } from 'react-router-dom';

function BookingConfirmation() {
  const { bookingId } = useParams();
  const [searchParams] = useSearchParams();
  const embed = searchParams.get('embed') === 'true';

  return (
    <div className={`${embed ? 'p-4' : 'min-h-screen bg-gray-50'} flex items-center justify-center px-4`}>
      <div className="max-w-md w-full">
        <div className={`${embed ? '' : 'bg-white rounded-lg shadow-lg'} p-8 text-center`}>
          <div className="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-green-100 mb-6">
            <svg
              className="h-10 w-10 text-green-600"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M5 13l4 4L19 7"
              />
            </svg>
          </div>

          <h2 className="text-2xl font-bold text-gray-900 mb-4">
            Booking Confirmed!
          </h2>

          <p className="text-gray-600 mb-6">
            Your appointment has been scheduled. You will receive a confirmation email shortly with all the details.
          </p>

          <div className="bg-gray-50 rounded-lg p-4 mb-6">
            <p className="text-sm text-gray-600">Booking ID</p>
            <p className="font-mono text-sm font-semibold text-gray-900">{bookingId}</p>
          </div>

          <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
            <p className="text-sm text-blue-800">
              Need to reschedule or cancel? Use the link in your confirmation email.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default BookingConfirmation;
